// extracted by css-extract-rspack-plugin
export default {"component":"j2rzMjP6mrAss40y"};